<template>
    <main-container>
        <div class="search" @keyup.enter="gotoSearch">
            <typo name="title-30-normal">{{ dico.title }}</typo>
            <sep name="M"> </sep>
            <typo name="body-16-light" v-if="total">{{ dico.subtitle | printf(total) }}</typo>
            <typo name="body-16-light" v-if="!total">{{ dico.subtitle | printf("") }}</typo>
            <sep name="S"> </sep>
            <v-row>
                <v-col lg="8"> <search-input-query v-model="query" /> </v-col>
                <v-col> <search-input-territories v-model="territory" /> </v-col>
                <v-col cols="1">
                    <action
                        :disabled="!this.query && !this.territory"
                        @click="gotoSearch"
                        name="submit"
                        :nochevron="true"
                        >OK</action
                    >
                </v-col>
            </v-row>
        </div>
    </main-container>
</template>

<script>
import SearchInputTerritories from "./SearchInputTerritories.vue";
import SearchInputQuery from "./SearchInputQuery.vue";
import { Services } from "src/services/Services";

export default {
    name: "Search",
    props: ["mode"],
    components: {
        SearchInputQuery,
        SearchInputTerritories,
    },
    data() {
        return {
            query: null,
            territory: { code: null },
            total: null,
            results: null,
        };
    },
    async mounted() {
        if (localStorage.getItem("query")) {
            this.query = JSON.parse(localStorage.getItem("query"));
        }
        if (localStorage.getItem("territory")) {
            this.territory = JSON.parse(localStorage.getItem("territory"));
        }

        await Services.search.waitConventions();
        this.total = Services.search.getTotalConventions();
        this.updateSearch();
    },
    computed: {
        dico() {
            return this.$privateDico.search;
        },
    },
    watch: {
        query() {
            localStorage.setItem("query", JSON.stringify(this.query));
            this.updateSearch();
        },
        territory() {
            localStorage.setItem("territory", JSON.stringify(this.territory));
            this.updateSearch();
        },
    },
    methods: {
        updateSearch() {
            if (!this.query || !Services) {
                this.$emit("input", null);
                return;
            }

            let conventions = {};
            if (typeof this.query == "object") {
                switch (this.query.type) {
                    case "text":
                        conventions = Services.search.searchConventionsText(
                            this.query.suggestion,
                            this.territory.code
                        );
                        this.search = this.query.suggestion;
                        break;
                    case "code":
                        switch (this.query.subtype) {
                            case "brochure":
                                conventions = Services.search.searchConventionsBrochures(
                                    this.query.suggestion,
                                    this.territory.code
                                );
                                break;
                            case "idcc":
                                conventions = Services.search.searchConventionsIdcc(
                                    this.query.suggestion,
                                    this.territory.code
                                );
                                break;
                            default:
                                conventions = Services.search.searchConventionsActivitiesCodes(
                                    this.query.suggestion,
                                    this.territory.code
                                );
                                break;
                        }
                        break;
                }
            } else {
                conventions = Services.search.searchConventionsText(
                    this.query,
                    this.territory.code
                );
            }

            this.$emit("input", conventions);
            this.$emit("query", this.query);

            this.results = conventions;
        },
        gotoSearch() {
            // Give time to save localStorage
            if (this.mode == "results") {
                setTimeout(() => this.updateSearch(), 10);
            } else {
                setTimeout(() => this.$router.push({ name: "cc" }), 10);
            }
        },
    },
};
</script>

<style scoped lang="sass">
.search
    background: $color-secondary
    padding: $padding-main
    +paddingContainer()

.typo
    color: white

.row
    +r(1024)
        flex-direction: column

.loading
    text-align: center
    margin: $grid-gutter 0
</style>
